import React, { useState, useEffect, useContext } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import '../../Project.less';
import { Tabs, Tab } from '../../../components/Tabs';
import TabDescription from '../../../components/strategyProject/tabs/TabDescription';
import TabTeam from '../../../components/strategyProject/tabs/TabTeam';
import TabIndex from '../../../components/strategyProject/tabs/TabIndex';
import TabPoliciesInfluence from '../../../components/strategyProject/tabs/TabPoliciesInfluence';
import TabIndexesInfluence from '../../../components/strategyProject/tabs/TabIndexesInfluence';
import TabConsortiumConnection from '../../../components/strategyProject/tabs/TabConsortiumConnection';
import TabProjectRegister from '../../../components/strategyProject/tabs/TabProjectRegister';
import TabPortfolioRegister from '../../../components/strategyProject/tabs/TabPortfolioRegister';
import api from '../../../api';
import BackBtn from '../../../components/UI/BackBtn';
import useUserContext from '../../../hooks/useUserContext';
import useNavProject from '../../../hooks/useNavProject';
import TabResults from '../../../components/strategyProject/tabs/TabResults/TabResults';
import { useStore } from '../../../stores/StoreHelpers';

export default function Project() {
  const { stratId } = useParams();
  const userCtx = useUserContext();
  const store = useStore();
  const history = useHistory();
  const navProject = useNavProject();
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [project, setProject] = useState([]);

  const tabs = [
    {
      label: 'description', tabName: 'Общая информация', content: <TabDescription data={project} />, show: true,
    },
    {
      label: 'team', tabName: 'Команда управления', content: <TabTeam data={project} />, show: true,
    },
    {
      label: 'index', tabName: 'Показатели', content: <TabIndex data={project} />, show: project.type !== 'policy',
    },
    {
      label: 'results', tabName: 'Выдающиеся результаты', content: <TabResults data={project} />, show: project.type !== 'policy',
    },
    {
      label: 'policiesinfluence', tabName: 'Влияние на политики ', content: <TabPoliciesInfluence data={project} />, show: project.type === 'strategy',
    },
    {
      label: 'indexesinfluence', tabName: 'Влияние на показатели ', content: <TabIndexesInfluence data={project} />, show: project.type === 'strategy',
    },
    {
      label: 'consortiumconnection', tabName: 'Связь с консорциумами ', content: <TabConsortiumConnection data={project} />, show: project.type === 'strategy',
    },
    {
      label: 'portfolios', tabName: 'Реестр портфелей ', content: <TabPortfolioRegister data={project} />, show: project.type !== 'policy',
    },
    {
      label: 'subprojectconnection', tabName: 'Реестр проектов ', content: <TabProjectRegister data={project} />, show: true,
    },
  ].filter((tab) => tab.show);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await api.get(`/info/strategies/${stratId}`);
        switch (result.type) {
          case 'strategy':
            navProject.setStratTitle(result.name);
            break;
          case 'policy':
            navProject.setPolicyTitle(result.name);
            break;
          case 'goal':
            navProject.setGoalTitle(result.name);
            break;
          case 'tech':
            navProject.setTechTitle(result.name);
            break;
          default:
            break;
        }

        setProject(result);
        setIsLoaded(true);
      } catch (err) {
        setIsLoaded(true);
        setError(err);
      }
    };
    fetchData();
  }, [stratId]);

  if (error) {
    return (
      <div style={{ color: 'red', background: 'white' }}>
        Ошибка:
        {error.message}
      </div>
    );
  } if (!isLoaded) {
    return <section className="page projects-page"><div className="container"><div>Загрузка...</div></div></section>;
  }
  return (
    <section className="page project-page">
      <div style={{ padding: '3em' }}>
        <BackBtn onClick={() => {
          store.strategies.clearStore();
          history.goBack();
        }}
        />
        <section className="page project-page">
          <div className="project-title-wrapper">
            {project.logo && (
              <div className="project-logo-wrapper">
                <img className="project-logo" src={`data:image/svg+xml;base64,${project.logo}`} alt="project-icon" />
                <div className="num">{project.num}</div>
              </div>
            )}
            <h3>
              {project.num}
              {' '}
              {project.name}
            </h3>
          </div>
          <Tabs>
            {tabs
              .filter((tab) => !tab.hide || !tab.hide(userCtx.perms))
              .map((tab, i) => (
                <Tab key={i} label={tab.label} tabName={tab.tabName}>
                  {tab.content}
                </Tab>
              ))}
          </Tabs>
        </section>
      </div>
    </section>
  );
}
